import { formatDate, type AccessEvent, type McpCopy } from '@/frontend/features/LocalMcp/types'

function describe(value: unknown, field: string, copy: McpCopy): string {
  if (field === 'praxis_workflow_permissions') {
    if (value === null || value === undefined) return copy.workflows_unrestricted
    if (typeof value === 'object' && !Array.isArray(value)) {
      return Object.entries(value).map(([organization, names]) => `${organization}: ${Array.isArray(names) && names.length ? names.join(', ') : copy.workflows_none}`).join('; ') || copy.workflows_none
    }
  }
  if (value === null || value === undefined || value === '') return '—'
  if (Array.isArray(value)) return field === 'capabilities' ? value.map((action) => copy[`action_${action}`] || action).join(', '): value.join(', ')
  if (typeof value === 'boolean') return value ? copy.boolean_true : copy.boolean_false
  if (field.endsWith('_at')) return formatDate(String(value))
  return copy[`${field}_${value}`] || String(value)
}
export default function AccessHistory({ events, copy }: { events: AccessEvent[]; copy: McpCopy }) {
  return <details className="mt-3 text-xs">
    <summary className="w-fit cursor-pointer text-muted-foreground hover:text-foreground">{copy.history}</summary>
    <ol className="mt-3 space-y-3 border-l border-border pl-3">{events.map((event) => <li key={event.id}>
      <p>{copy[`event_${event.event_type}`] || event.event_type} · {event.actor_name} · {formatDate(event.created_at)}</p>
      <dl className="mt-1 space-y-1 text-muted-foreground">{Object.entries(event.details).map(([field, change]) => <div key={field}>
        <dt className="inline font-medium">{copy[`field_${field}`] || field}: </dt>
        <dd className="inline break-words">{describe(change.before, field, copy)} → {describe(change.after, field, copy)}</dd>
      </div>)}</dl>
    </li>)}</ol>
    {!events.length && <p className="mt-2 text-muted-foreground">{copy.no_history}</p>}
  </details>
}
